import { LogoSmall } from '@/resources/assets/images';
import HeaderRedesign from '@/modules/main/components/HeaderRedesign/HeaderRedesign';
import { useIsScreenWidthSmallerThan } from '@/hooks/useIsScreenWidthSmallerThan';
import NewSequenceContainer from '../components/sequenceStartPage/NewSequenceContainer';
import NewSequenceFooter from '../components/NewSequenceFooter';
import { useSequencesContext } from '../SequencesContext';
import SequencesStepsList from '../components/StepsList';

export default function SequenceStartPage() {
	const { selectedTemplate, setSequencePage } = useSequencesContext();

	const goBackHomePage = () => {
		setSequencePage('MY-SEQUENCES');
	};

	const screenSize = useIsScreenWidthSmallerThan(1024);

	return (
		<div className="flex h-full flex-col text-dm-white">
			<HeaderRedesign
				backButton={{
					goBack: goBackHomePage,
					label: 'Back to My Sequences'
				}}
				title="New Sequence creation"
			/>
			<div className="mb-2 mt-3 flex h-full w-full justify-center gap-2 overflow-hidden lg:justify-start">
				<NewSequenceContainer />
				{!screenSize.isSmaller &&
					(selectedTemplate ? (
						<SequencesStepsList steps={selectedTemplate.steps} />
					) : (
						<NewSequenceTooltipContainer />
					))}
			</div>
			<NewSequenceFooter />
		</div>
	);
}

function NewSequenceTooltipContainer() {
	return (
		<div className="flex h-full flex-col rounded-l-lg border-b border-l border-t border-dm-grey bg-dm-black p-10">
			<div className="mb-6 flex h-20 items-center gap-3 rounded-xl bg-dm-black3 px-10">
				<LogoSmall />
				<h6 className="text-lg font-semibold text-white">
					Would you like to select a sequence template?
				</h6>
			</div>
			<div className="h-full rounded-xl bg-dm-black3 px-10 py-11">
				<p className="text-dm-mid-grey">
					Embrace the flexibility to create your sequence from
					scratch, tailoring each element to resonate with your unique
					audience.
					<br />
					<br />
					Alternatively, opt for one of our expertly crafted pre-made
					templates for a fast and efficient setup, ensuring a smooth
					start to your sequence.
					<br />
					<br /> Whichever path you choose, you&apos;re empowered to
					engage your audience in a manner that aligns perfectly with
					your specific goals and style.
				</p>
			</div>
		</div>
	);
}
